import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getEndDate, getStartDate, getTimeDiffWithUTC } from "../../../../utils/dateFormatUtils";
import NavBarComponent from "../../navbar/NavBar.component";
import BestProductGraphComponent from "./best-product-graph/BestProductGraph.component";
import ConditionSearchComponent from "./condition-search/ConditionSearch.component";
import DateOperatorComponent from "./date-operator/DateOperator.component";
import GraphDataPagenationComponent from "./graph-data-pagenation/GraphDataPagenation.component";
import GraphOperatorComponent from "./graph-operator/GraphOperator.component";
import useSalesChannelOptionAnalysisHook from "./hooks/useSalesChannelOptionAnalysisHook";
import useSalesChannelProductAnalysisHook from "./hooks/useSalesChannelProductAnalysisHook";
import { Container } from "./index.styled";
import DetailGraphSelectorModalComponent from "./modal/detail-graph-selector/DetailGraphSelector.component";
import OptionItemComponent from "./option-item/OptionItem.component";
import TextInfoComponent from "./text-info/TextInfo.component";
import useRouterHookV2 from "../../../../hooks/router/useRouterHookV2";
import { customToast, defaultOptions } from "../../../../components/toast/custom-react-toastify/v1";
import _ from "lodash";

export default function SalesAnalysis_SalesChannelBestProductComponent () {
    const workspaceRedux = useSelector(state => state.workspaceRedux);

    const [checkedSwitch, setCheckedSwitch] = useState(false);
    const [checkedExcludedDeliveryChargeSwitch, setCheckedExcludedDeliveryChargeSwitch] = useState(false);
    
    const [detailGraphSelectorModalOpen, setDetailGraphSelectorModalOpen] = useState(null);
    
    const [pageOrderByColumn, setPageOrderByColumn] = useState('payAmount');
    const [pageIndex, setPageIndex] = useState(0);

    const [sortedProductAnalysis, setSortedProductAnalysis] = useState(null);

    const router = useRouterHookV2();

    const {
        isLoading: isProductAnalysisLoading,
        analysis : productAnalysis,
        reqSearchChannelBestProductAnalysis,
    } = useSalesChannelProductAnalysisHook({ pageOrderByColumn });

    const {
        isLoading: isOptionAnalysisLoading,
        analysis : optionAnalysis
    } = useSalesChannelOptionAnalysisHook({ productAnalysis });

    useEffect(() => {
        if ((!(router.state?.salesChannels?.length > 0) && !router.state?.includeUndefinedSalesChannelFlag)) {
            let memo = '스토어별 상품 순위를 확인하기 위해 스토어를 먼저 선택해주세요.\n[판매스토어 총 매출액 & 판매 건] 페이지로 이동합니다.';
            customToast.warning(memo, {
                ...defaultOptions,
                toastId: memo
            })
            router.push({ pathname: '/sales-analysis/sales-channel' });
            return;
        }
    }, [])

    useEffect(() => {
        if(productAnalysis?.content?.length > 0) {
            setPageIndex(productAnalysis?.number)
        }
    }, [productAnalysis])
    
    useEffect(() => {
        if(!productAnalysis?.content) {
            return;
        }

        handleUpdateBestProductIds();
    }, [productAnalysis, checkedExcludedDeliveryChargeSwitch])

    const handleChangeSwitch = () => {
        let checkedValue = checkedSwitch;
        setCheckedSwitch(!checkedValue);
    }

    const handleChangeExcludedDeliveryChargeSwitch = () => {
        let checkedValue = checkedExcludedDeliveryChargeSwitch;
        setCheckedExcludedDeliveryChargeSwitch(!checkedValue);
    }

    const handleUpdateBestProductIds = () => {
        let analysis = [...productAnalysis?.content]
        let sortField = checkedExcludedDeliveryChargeSwitch ? 'excludedDeliveryChargeSalesPayAmount' : 'salesPayAmount';
        let sortedAnalysis = _.orderBy(analysis, sortField, 'desc');
        
        setSortedProductAnalysis([...sortedAnalysis])
    }

    const handleChangePrevPageIndex = () => {
        let page = pageIndex - 1;

        let body = {
            startDate: getStartDate(router.query.startDate),
            endDate: getEndDate(router.query.endDate),
            utcHourDifference: getTimeDiffWithUTC(),
            salesChannels: router.state?.salesChannels,
            includeUndefinedSalesChannelFlag: router.state?.includeUndefinedSalesChannelFlag ?? false,
            periodType: router.query.periodType ?? 'registration'
        }

        let params = {
            page: page + 1,
            sort: pageOrderByColumn + '_desc'
        }

        let headers = {
            wsId: workspaceRedux?.workspaceInfo.id
        }

        setPageIndex(page);
        handleSubmitSearchPerformance(body, params, headers);
    }

    const handleChangeNextPageIndex = () => {
        let page = pageIndex + 1;
        let body = {
            startDate: getStartDate(router.query.startDate),
            endDate: getEndDate(router.query.endDate),
            utcHourDifference: getTimeDiffWithUTC(),
            salesChannels: router.state?.salesChannels,
            includeUndefinedSalesChannelFlag: router.state?.includeUndefinedSalesChannelFlag ?? false,
            periodType: router.query.periodType ?? 'registration'
        }

        let params = {
            page: page + 1,
            sort: pageOrderByColumn + '_desc'
        }

        let headers = {
            wsId: workspaceRedux?.workspaceInfo.id
        }

        setPageIndex(page);
        handleSubmitSearchPerformance(body, params, headers);
    }

    const handleChangePageOrderByColumn = (e) => {
        let value = e.target.value;

        let body = {
            startDate: getStartDate(router.query.startDate),
            endDate: getEndDate(router.query.endDate),
            utcHourDifference: getTimeDiffWithUTC(),
            salesChannels: router.state?.salesChannels,
            includeUndefinedSalesChannelFlag: router.state?.includeUndefinedSalesChannelFlag ?? false,
            periodType: router.query.periodType ?? 'registration'
        }

        let params = {
            page: 0,
            sort: value + '_desc'
        }

        let headers = {
            wsId: workspaceRedux?.workspaceInfo.id
        }

        setPageOrderByColumn(value);
        setPageIndex(0);
        handleSubmitSearchPerformance(body, params, headers);
    }

    const handleActionOpenDetailGraphSelectorModal = () => {
        setDetailGraphSelectorModalOpen(true);
    }

    const handleActionCloseDetailGraphSelectorModal = () => {
        setDetailGraphSelectorModalOpen(false);
    }

    const handleSubmitSearchPerformance = async (body, params, headers) => {
        await reqSearchChannelBestProductAnalysis(body, params, headers)
    }

    return (
        <>
            <Container>
                <NavBarComponent
                    sidebarName={'판매스토어 성과'}
                    headerName={'상품 순위'}
                    sidebarColor={'#ffffff'}
                >
                    <>
                        <TextInfoComponent />
                        
                        <ConditionSearchComponent />

                        <GraphOperatorComponent
                            checkedSwitch={checkedSwitch}
                            checkedExcludedDeliveryChargeSwitch={checkedExcludedDeliveryChargeSwitch}

                            onActionChangeSwitch={handleChangeSwitch}
                            onChangeExcludedDeliveryChargeSwitch={handleChangeExcludedDeliveryChargeSwitch}
                        />

                        <BestProductGraphComponent
                            isProductAnalysisLoading={isProductAnalysisLoading}
                            checkedSwitch={checkedSwitch}
                            checkedExcludedDeliveryChargeSwitch={checkedExcludedDeliveryChargeSwitch}
                            analysis={sortedProductAnalysis}
                            
                            onActionOpenDetailGraphSelectorModal={handleActionOpenDetailGraphSelectorModal}
                        />

                        <GraphDataPagenationComponent
                            pageOrderByColumn={pageOrderByColumn}
                            productAnalysis={productAnalysis}
                            pageIndex={pageIndex}

                            onChangePrevPageIndex={handleChangePrevPageIndex}
                            onChangeNextPageIndex={handleChangeNextPageIndex}
                            onActionChangePageOrderByColumn={handleChangePageOrderByColumn}
                        />

                        <OptionItemComponent
                            isOptionAnalysisLoading={isOptionAnalysisLoading}
                            checkedSwitch={checkedSwitch}
                            checkedExcludedDeliveryChargeSwitch={checkedExcludedDeliveryChargeSwitch}
                            optionAnalysis={optionAnalysis}
                            pageOrderByColumn={pageOrderByColumn}
                            productAnalysis={sortedProductAnalysis}
                        />
                    </>
                </NavBarComponent>

                <DateOperatorComponent
                    pageOrderByColumn={pageOrderByColumn}
                    onSubmitSearchPerformance={handleSubmitSearchPerformance}
                />
            </Container>

            <DetailGraphSelectorModalComponent
                modalOpen={detailGraphSelectorModalOpen}

                onActionCloseModal={handleActionCloseDetailGraphSelectorModal}
            />
        </>
    )
}
